import { MultiSelectDropdown } from 'components/common'
import { memo, useEffect, useState } from 'react'
import { fetchStores } from 'utils/api/storeApi'

type Props = {
  setValue: any
  resetForm: any
  error?: string
  label: string
  name: string
  required?: boolean
  defaultSelected?: []
  isActive?: boolean
}

const MultiSelectStoreDropdown = ({
  setValue,
  error,
  label,
  name,
  required = false,
  defaultSelected,
  isActive,
  resetForm,
}: Props) => {
  const [options, setOptions] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(true)

  const getStores = async () => {
    try {
      const { data } = await fetchStores({
        limit: 500,
        page: 1,
        isActive,
      })
      const stores = data?.docs?.map((store: any) => ({
        label: store.storeName,
        value: store._id,
        disabled: false,
      }))

      if (!stores || stores.length <= 0) {
        return setOptions([])
      }
      setOptions(stores)
    } catch (error) {
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStores()
  }, [])

  if (loading) {
    return <></>
  }

  return (
    <MultiSelectDropdown
      required={required}
      label={label}
      name={name}
      setValue={setValue}
      error={error}
      includeSelectAll={options?.length > 0}
      defaultSelected={defaultSelected}
      options={
        options.length <= 0
          ? [
              {
                label: 'No Stores Found',
                value: 'NO_STORES',
                disabled: true,
              },
            ]
          : options
      }
      reset={resetForm}
    />
  )
}

export default memo(MultiSelectStoreDropdown)
